"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventAppointmentCell = exports.SeverityCell = exports.ActionCell = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _check = _interopRequireDefault(require("../icons/check.svg"));

var _online = _interopRequireDefault(require("../icons/online.svg"));

var _alert = _interopRequireDefault(require("../icons/alert.svg"));

var _alarm = _interopRequireDefault(require("../icons/alarm.svg"));

var _offline = _interopRequireDefault(require("../icons/offline.svg"));

var _info = _interopRequireDefault(require("../icons/info.svg"));

var _Button = _interopRequireDefault(require("../Button"));

var _ref = _react.default.createElement("center", null, _react.default.createElement(_check.default, null));

var ActionCell =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(ActionCell, _PureComponent);

  function ActionCell() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ActionCell);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ActionCell)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onClick", function (e) {
      e.stopPropagation();
      _this.props.onClick && _this.props.onClick();
    });
    return _this;
  }

  (0, _createClass2.default)(ActionCell, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isChecked = _this$props.isChecked,
          disabled = _this$props.disabled,
          Icon = _this$props.Icon;

      if (isChecked) {
        return _ref;
      }

      return _react.default.createElement(_Button.default, {
        primary: true,
        small: true,
        disabled: disabled,
        onClick: this.onClick
      }, Icon && _react.default.createElement(Icon, null));
    }
  }]);
  return ActionCell;
}(_react.PureComponent);

exports.ActionCell = ActionCell;

var getSeverityIcon = function getSeverityIcon(severity) {
  switch (severity) {
    case 'online':
      return _online.default;

    case 'offline':
      return _offline.default;

    case 'alert':
      return _alert.default;

    case 'alarm':
      return _alarm.default;

    default:
      return _info.default;
  }
};

var getSeverityClass = function getSeverityClass(severity) {
  switch (severity) {
    case 'alarm':
    case 'offline':
      return 'danger';

    case 'alert':
      return 'warning';

    default:
      return 'info';
  }
};

var SeverityCell = function SeverityCell(_ref2) {
  var severity = _ref2.severity,
      description = _ref2.description;
  var Icon = getSeverityIcon(severity);
  return _react.default.createElement("span", {
    className: 'severity severity--' + getSeverityClass(severity)
  }, _react.default.createElement(Icon, {
    className: "severity-icon"
  }), description);
};

exports.SeverityCell = SeverityCell;

var EventAppointmentCell = function EventAppointmentCell(_ref3) {
  var zone = _ref3.zone,
      appointment = _ref3.appointment,
      partitions = _ref3.partitions;

  if (!zone) {
    return _react.default.createElement("span", null, appointment);
  }

  return _react.default.createElement("div", null, "#", zone, " ", appointment, partitions && _react.default.createElement("span", {
    className: "partitions"
  }, partitions.map(function (partition) {
    return _react.default.createElement("span", {
      key: partition,
      className: "partition"
    }, partition);
  })));
};

exports.EventAppointmentCell = EventAppointmentCell;